import React, { Fragment, useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import Toast from "../toast/SetToast";
import { notifyTopRight, notifyWarning, notifyError } from "../toast/SetToast";
import { db } from "../../../firebase";
import { setDoc, getDoc, updateDoc, doc, collection } from "firebase/firestore";
import { ItemEditForm } from "./ItemEditForm";
import { useFirestore } from "../../../hook/useFirestore";

const ItemEdit = (props) => {
  const { updateDocument } = useFirestore("items");
  const inputRef = useRef({
    itemId: "",
    item: "",
    unitcost: "",
    description: "",
    node: "",
    category: "",
    IsActive: "",
  });

  const handleChange = (name) => (e) => {
    inputRef.current[name] = e.target.value;
  };
  const handleOnHideModal = () => {
    props.hide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      itemId: inputRef.current.itemId
        ? inputRef.current.itemId
        : props.item.itemId,
      item: inputRef.current.item ? inputRef.current.item : props.item.item,
      unitcost: inputRef.current.unitcost
        ? inputRef.current.unitcost
        : props.item.unitcost,
      description: inputRef.current.description
        ? inputRef.current.description
        : props.item.description,
      node: inputRef.current.node ? inputRef.current.node : props.item.node,
      category: inputRef.current.category
        ? inputRef.current.category
        : props.item.category,
      IsActive: inputRef.current.IsActive
        ? inputRef.current.IsActive
        : props.item.IsActive,
    };

    updateDocument(props.item.id, formData)
      .then(() => {
        notifyTopRight("บันทึกข้อมูลสำเร็จ");
      })
      .catch((err) => {
        notifyError("บันทึกข้อมูลผิดพลาด ", err);
      });

    props.hide();

    inputRef.current.itemId = "";
    inputRef.current.item = "";
    inputRef.current.unitcost = "";
    inputRef.current.description = "";
    inputRef.current.node = "";
    inputRef.current.category = "";
    inputRef.current.IsActive = "";
  };

  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={props.show}
        onHide={handleOnHideModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Edit Order Datails</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ItemEditForm onChange={handleChange} initailValues={props.item} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>

          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleOnHideModal}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default ItemEdit;
